function initTracklist() {
  const accordion = document.querySelector(".js-tracklist");

  if (!accordion) {
    return;
  } else {
    const products = gsap.utils.toArray(".js-tracklist-product");
    const titles = gsap.utils.toArray(".js-tracklist-title");
    const animations = [];

    products.forEach((product) => createAnimation(product));

    titles.forEach((title) => {
      title.addEventListener("click", () => 
        toggleAnimation(title));
    });

    function toggleAnimation(title) {

      let parent = title.parentElement;
      
      products.forEach((product) => {
        product.classList.remove('active');
      });

      parent.classList.add('active');
      

      // Save the current state of the clicked animation
      const selectedReversedState = title.animation.reversed();

      // Reverse all animations
      animations.forEach((animation) => animation.reverse());

      // Set the reversed state of the clicked tracklist element to the opposite of what it was before
      title.animation.reversed(!selectedReversedState);
    }

    function createAnimation(element) {
      const title = element.querySelector(".js-tracklist-title");
      const infos = element.querySelector(".js-tracklist-content");
      const product = infos.parentElement;

      gsap.set(product, { flexGrow: 0 });

      const tlAccordion = gsap.timeline({
        reversed: true,
        paused: !0
      });

      tlAccordion
        .to(product, {
          flexGrow: 10,
          duration: 1,
          ease: "power1.inOut"
        })
        .to(title, {
            backgroundColor: '#754B29',
            color: '#FFFAEA',
            ease: "power1.inOut"
        }, "<")
        .duration(0.5);
        // .from( infos, {
        //     opacity: 0,
        //     // y: 80,
        //     duration: 1,
        //     ease: "power1.inOut",
        //   }, "<"
        // );


      title.animation = tlAccordion;
      animations.push(tlAccordion);
    }
    toggleAnimation(titles[0])
  }
}

initTracklist();